import { Skeleton } from "src/design-system/Skeleton";

export const ChatMessageSkeleton: React.FC<{ dataLoc?: string }> = ({
  dataLoc,
}) => (
  <li className="flex flex-col gap-y-2" data-loc={dataLoc}>
    <Skeleton height="h-3" width="w-14" />
    <Skeleton height="h-4" width="w-full" />
    <Skeleton height="h-4" width="w-full" />
    <Skeleton height="h-4" width="w-3/4" />
  </li>
);
